import React from 'react';
import { Container, Col, Row  } from 'react-bootstrap';
import Switch from './Switch';

function SwitchDemo({ children }: any) {
  return (
    <Container>
      <Container className="mt-10">
        <Row>
          <Col className="d-flex flex-column">
            <h4>Default Switches</h4>
            <Switch value="xl" variant="xl" className="mt-6" />
            <Switch value="xl" className="mt-6" />
            <Switch value="xl" variant="sm" className="mt-6" />
          </Col>
          <Col className="d-flex flex-column">
            <h4>Checked Switches</h4>
            <Switch value="xl" variant="xl" className="mt-6" defaultChecked />
            <Switch value="xl" className="mt-6" defaultChecked />
            <Switch value="xl" variant="sm" className="mt-6" defaultChecked />
          </Col>
          <Col className="d-flex flex-column">
            <h4>Disabled Switches</h4>
            <Switch value="xl" variant="xl" className="mt-6" disabled />
            <Switch value="xl" className="mt-6" disabled />
            <Switch value="xl" variant="sm" className="mt-6" disabled />
          </Col>
        </Row>
        <Container className="mt-10 p-0">
          <h4>Switches with labels</h4>
          <Container className="d-flex justify-content-between flex-wrap align-items-center mt-10 p-0">
            <Switch value="xl" variant="xl" label={'Switch label'} id="s1" className="mt-6" isLeftLabel/>
            <Switch value="xl" className="mt-6"  label={'Switch label'} id="s2" isLeftLabel defaultChecked />
            <Switch value="xl" variant="sm" className="mt-6"  label={'Switch label'} id="s3" />
            <Switch value="xl" variant="xl" className="mt-6"  label={'Switch label'} disabled />
            <Switch value="xl" className="mt-6"  label={'Switch label'} defaultChecked disabled />
            <Switch value="xl" variant="sm" className="mt-6"  label={'Switch label'} disabled />
          </Container>
        </Container>
      </Container>
    </Container>
  );
}

export default SwitchDemo;
